<template>
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
                <div class="form-row">
                    <div class="col-md-11">
                        <h4 class="header-title mb-4"><h4 class="page-title">{{$t('string.msg.trucktrailer.list.label.title')}}</h4></h4>
                    </div>
                    <div class="col-md-1" v-if="items">
                        <h4 class="text-center">{{$t('str.total')}}</h4>
                        <h4 class="text-center" style="color:grey">{{items.length}}</h4>
                    </div>
                </div>

                <p class="sub-header">
                    {{$t('string.msg.trucktrailer.search.description')}}
                </p>

                <form>
                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <label class="col-form-label">
                                {{$t('string.msg.trucktrailer.register.manufacturs.label')}}
                            </label>
                            <select id="manufacturer" v-model="filters.manufacturer" class="form-control">
                                <option value="" selected>{{$t('string.msg.select.selector.item')}}</option>
                                <option :value="item._id" v-bind:key="item" v-for="item in manufacturers">{{camelize(item.name).split('ZZZ_').join('')}}</option>
                            </select>
                        </div>
                         <div class="form-group col-md-6">
                            <label class="col-form-label">
                                {{$t('string.msg.trucktrailer.register.plate.label')}}
                            </label>
                            <input type="text" onkeyup="this.value = this.value.toUpperCase();" v-model="filters.plate" class="form-control" v-mask="['AAA #X##']" :placeholder="$t('string.msg.truck.register.placeholder.plate')">
                        </div>
                    </div>

                    <br/>
                    <div class="d-flex justify-content-between bd-highlight mb-3">
                        <button @click="filter" class="btn btn-success w-20">{{$t('string.msg.form.btn.search')}}</button>
                           <download-excel v-if="items.length>0"
                                class   = "btn btn-primary"
                                :fetch   = "fetchData"
                                :fields = "json_fields"
                                :meta = "json_meta"
                                type    = "csv"
                                name    = "truckTrailers-geral.xls">
                                Download CSV
                            </download-excel>
                    </div>
                </form>
                   <div class="pb-0 pt-3 ">
                        <jw-pagination :items="items" @changePage="onChangePage"></jw-pagination>
                </div>
                <div id="vue-table">
                    <div class="table-responsive">
                        <table class="table table-centered table-hover mb-0" id="datatable">
                            <thead>
                                <tr>
                                    <th class="border-top-0">{{$t('string.msg.trucktrailer.register.manufactures.label')}}</th>
                                    <th class="border-top-0">{{$t('string.msg.register.truck.type.model.label.group')}}</th>
                                    <th class="border-top-0">{{$t('string.msg.trucktrailer.table.header.year')}}</th>
                                    <th class="border-top-0">{{$t('string.msg.trucktrailer.table.header.Placa')}}</th>
                                    <th class="border-top-0">{{$t('string.msg.trucktrailer.table.header.owner')}}</th>
                                </tr>
                            </thead>
                            <tbody v-bind:key="item._id" v-for="item in pageOfItems" class="cursor-pointer" @click="selectItem(item)">
                                 <tr v-if="item && item.status == 'ACTIVE'">
                                    <td v-if="item.manufacturer">
                                        <span>
                                            {{item.manufacturer.name}}
                                        </span>
                                    </td>
                                    <td>
                                        <span v-if="item.specie">
                                            {{item.specie}}
                                        </span>
                                    </td>
                                    <td>
                                        <span>
                                            {{item.year}}
                                        </span>
                                    </td>
                                    <td>
                                        <span>   
                                            {{item.plate}}
                                        </span>
                                    </td>
                                    <td>
                                        <span v-if="item.truckDriver">   
                                            {{camelize(item.truckDriver.firstName) + ' ' + camelize(item.truckDriver.lastName)}}
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

            </div>
        </div>
        <Toast :title="titleToast" :message="messageToast" :messageId="messageIdToast" />
    </div>
</template>

<script>
import Controller from './CrtListTruckTrailer';
import Spinner from '../../../components/layout/Spinner';
import Toast from '../../../components/layout/Toast';
import Vue from 'vue'
import JsonExcel from 'vue-json-excel'
import JwPagination from 'jw-vue-pagination';
Vue.prototype.$eventHub = new Vue();
Vue.component('jw-pagination', JwPagination);
Vue.component('downloadExcel', JsonExcel);

export default {
  name: 'ListTruckTrailer',
  props: ["valuekey"],

  components: {
    Spinner,
    Toast
  },
 
  data() {
      return {
        PageNumbers:1,
        pageOfItems: [],
        errors: [],
        titleToast: null,
        messageToast: null,
        messageIdToast: null,
        items: [],
        certifies:[],
        manufacturers: [],
        filters: {
            manufacturer: "",
            plate:null,
            vehicleTypes:["TRUCKTRAILER_VANDERLEIA", "TRUCKTRAILER_CONVENCIONAL" ,"TRUCKTRAILER_DOLLY"]
        },
        json_fields: {
            'Tipo': 'vehicleType',   
            'Fabricante': 'manufacturer.name',
            'Modelo': 'model.name',
            'Ano de Fabricacao': 'year',
            'Ano do Modelo': 'yearModel',
            'Placa': 'plate',
            'RENAVAM': 'renavam',
            'Chassi': 'chassi',
            'Cor': 'color',
            'PBT': 'pbt',
            'Nome Proprietario': 'truckDriver.firstName',
            'Sobrenome Proprietario': 'truckDriver.lastName',
            'E-mail Proprietario': 'truckDriver.email',
            'Telefone Proprietario': 'truckDriver.primaryPhone',
            'CPF Proprietario': 'truckDriver.customerUser.document',
            'CNH Proprietario': 'truckDriver.customerUser.cnh',
            'Certificados':  'certifies.certified.name',
        },
        json_data: [
            {
                vehicleType: null,
                manufacturer:{
                    name: null
                },
                model:{
                    name:null
                },
                year: null,
                yearModel: null,
                plate: null,
                renavam: null,
                chassi: null,
                color: null,
                pbt: null,
                truckDriver:{
                    firstName: null,
                    lastName: null,
                    email: null,
                    primaryPhone: null,
                    customerUser:{
                        document: null,
                        cnh: null,
                    }

                },
                certifies:[{
                    certified:{
                        name: null
                    }
                }]  
            },  
        ],
        json_meta: [
			[{
				"key": "charset",
				"value": "utf-8"
			}]
		],
      }
  },
  methods: Controller.methods,
  created() {
    Controller.init(this);
    let state = this;
    this.$eventHub.$on('refreshList', function(){
        state.filter();
    })
  },
  mounted(){
  }

}
</script>

<style>
</style>
